// Search Results

import React from 'react'

function SearchResults() {
  return (
    <div>
      This is search results page.
    </div>
  )
}

export default SearchResults
